var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customScenario[0].data.length)?_c('VueApexCharts',{attrs:{"type":"area","width":"100%","height":"400","options":_vm.customScenarioChartOptions,"series":_vm.customScenario}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }